/**
 * Extracts the major version number of iOS from the user agent string.
 *
 * @param {string} [ua=navigator.userAgent] - The user agent string to parse.
 *                                            If not provided, defaults to the browser's user agent.
 * @returns {number | null} The major version number of iOS, or `null` if the version number cannot be determined.
 */
export default function getIOSVersion(ua = navigator.userAgent) {
    const match = ua.match(/OS (\d+)[._]\d+/i);
    if (match && match[1]) {
        return parseInt(match[1], 10);
    }
    return null;
}
